import { Button, Col, Row } from "antd";
import { useHistory } from "react-router";
import { SuccessIcon, TierHubLogo } from "src/assets/icons";
import { PATHS } from "src/constants/paths";
import "./styles.scss";

const PasswordChanged = () => {
  const history = useHistory();
  const onBackToLogin = () => {
    history.push(PATHS.login());
  };

  return (
    <Row className="login-page password-changed">
      <Col span={12} className="banner-img"></Col>
      <Col span={12} className="login-area">
        <div className="login-page__wrapperLogo">
          <img src={TierHubLogo} alt="login-background" />
          <div className="ver-divider"></div>
          <p>TIER HUB is a tracking and tracing system for sea-product</p>
        </div>
        <div className="login-page__form">
          <img src={SuccessIcon} alt="success" />
          <div>
            <h1>Password changed</h1>
            <p>You may login with new password</p>
          </div>
          <Button
            onClick={onBackToLogin}
            size="large"
            type="primary"
            className="back-btn primary-btn"
          >
            Back to login
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default PasswordChanged;
